import { createSlice } from '@reduxjs/toolkit'

export interface IImageReducer {
    image: File | undefined
}
const initialState: IImageReducer = {
    image: undefined,
}
export const imageReducer = createSlice({
    name: 'imageReducer',
    initialState,
    reducers: {
        toggleImage: (state, action: { payload: { image: File } }) => {
            state.image = action.payload.image
        },
        resetImage: () => initialState,
    },
})

export const { toggleImage, resetImage } = imageReducer.actions

export default imageReducer.reducer
